import { CheckboxWrapper } from "../wrapper";
import { styled } from "@mui/material/styles";

export const Checkbox = styled(CheckboxWrapper)(() => ({
    borderRadius: '0.5rem'
}))